import { HobbiesInterestsOptionsType } from './types';

export const HOBBIES_INTERESTS_OPTIONS: HobbiesInterestsOptionsType = [
  { id: 'fitness_gym', title: 'Fitness & gym', icon: '👟' },
  { id: 'art_culture', title: 'Art & culture', icon: '🖼️' },
  { id: 'music_festivals', title: 'Music & festivals', icon: '🎸' },
  { id: 'gaming_tech', title: 'Gaming & tech', icon: '🎮' },
  { id: 'cooking_foodie', title: 'Cooking & foodie', icon: '🥑' },
  { id: 'travel_adventure', title: 'Travel & adventure', icon: '🌍' },
];
